/**
 *
 * appContainer
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */
import React from 'react';
import { Helmet } from 'react-helmet';
import { renderRoutes } from 'react-router-config';
import routes from '../routes';
import { ThemeProvider } from '@material-ui/styles';
import { ConnectedRouter } from 'connected-react-router';
import { Provider as StoreProvider } from 'react-redux';
import configureStore from '../store/configureStore';
import { history } from '../utils';
import theme from '../theme';
import { PersistGate } from 'redux-persist/integration/react';
import LanguageProvider from '../components/LanguageProvider';
import GlobalComponents from '../components/GlobalComponents';
import '../assets/scss/index.scss';

const initialState = {};


const { store, persistor } = configureStore(initialState, history);

const AppContainer = () => (
  <StoreProvider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider theme={theme}>
        <LanguageProvider>
          <ConnectedRouter history={history}>
            <Helmet defaultTitle="Watch My Health" titleTemplate="%s - WMH">
              <meta content="Watch My Health" name="description" />
            </Helmet>
            <GlobalComponents />
            {renderRoutes(routes)}
          </ConnectedRouter>
        </LanguageProvider>
      </ThemeProvider>
    </PersistGate>
  </StoreProvider>
);

export default AppContainer;
export { store };
